import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';

@Component({
  selector: 'lgv-long-url-navigator',
  templateUrl: './long-url-navigator.component.html',
  styleUrls: ['./long-url-navigator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LongUrlNavigatorComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.data.pipe(first()).subscribe((data) => {
      window.location = data.longUrl;
    });
  }

}
